import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-multi-images-with-text',
  templateUrl: './multi-images-with-text.component.html',
  styleUrls: ['./multi-images-with-text.component.css'],
})
export class MultiImagesWithTextComponent {
  @Input() data!: any;
  @Input() fileName!: string;
  @Input() language!: string;
  getDetailsUrl(object: any): string {
    return `/${this.language}/details/${this.fileName}/${object.title
      .replaceAll(' ', '-')
      .toLowerCase()}`;
  }
}
